import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { ChevronDown, Weight } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

function Whitepapers3() {
  const [loading, setLoading] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [formType, setFormType] = useState(""); // stores which button opened the form
const [contactForm, setContactForm] = useState({
  fullname: "",
  company: "",
  website: "",
  email: "",
  phone: "",
  message: "",
});
const handleContactChange = (e) => {
  const { name, value } = e.target;
  setContactForm((prev) => ({ ...prev, [name]: value }));
};


const isBusinessEmail = (email) => {
  const freeDomains = [
    "gmail.com",
    "yahoo.com",
    "hotmail.com",
    "outlook.com",
    "aol.com",
    "icloud.com",
    "mail.com",
    "live.com"
  ];
  const domain = email.split("@")[1]?.toLowerCase();
  if (!domain) return false;
  return !freeDomains.includes(domain);
};


const handleContactSubmit = async (e) => {
  e.preventDefault();
 
  setLoading(true); // show loading message
  const { fullname, company, website, email, phone, message} = contactForm;


  // Basic validation
  if (!fullname || !email || !message || !company || !phone ) {
    alert("Please fill all required fields.");
      setLoading(false); // show loading message

    return;
  }
if (!isBusinessEmail(email)) {
    alert("Please enter a business email, not Gmail/Yahoo/etc.");
      setLoading(false); // show loading message

    return;
  }
 

  try {
     try {
    const emailCheckResponse = await fetch(
      `https://pinakinedgemedia.com/api/validateEmail?email=${email}`
    );
    const emailCheckData = await emailCheckResponse.json();

    if (!emailCheckData.exists) {
      setLoading(false);
      alert("❌ The entered email does not exist. Please use a valid business email.");
      return;
    }
  } catch (err) {
    setLoading(false);
    console.error("Email check failed:", err);
    alert("⚠️ Could not verify email existence. Try again later.");
    return;
  }
    const response = await fetch("https://pinakinedgemedia.com/api/sendContactMail", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
  ...contactForm,
  formType, // ✅ add formType manually here
}),

    });

    if (response.ok) {
       setShowSuccessModal(true);  // ✅ This triggers modal to open
       setLoading(false); // show loading message
       setContactForm({
        fullname: "",
        company: "",
        website: "",
        email: "",
        phone: "",
        message: "",
      });
    } else {
      alert("Error sending message.");
    }
  } catch (err) {
    console.error(err);
    alert("Error sending message.");
  }
};
  
  return (
    <div>
      <Header />
      <main>
         <AnimatePresence>
        {showSuccessModal && (
          <motion.div
            className="modal-overlay show"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(0,0,0,0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 9999,
            }}
          >
            <motion.div
              className="modal show"
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
              transition={{ duration: 0.3 }}
              style={{
                background: "#fff",
                padding: "30px",
                borderRadius: "10px",
                width: "400px",
                textAlign: "center",
                boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
              }}
            >
              <h2 style={{ fontSize: "20px", marginBottom: "10px" }}>
                Message Sent!
              </h2>
              <p>Thank you for contacting us. We will get back to you shortly.</p>
              <button className="vc rg lk gh ml il hi gi _l"
                onClick={() => setShowSuccessModal(false)}
               
              >
                Close
              </button>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
      
        {/* 🔹 FAQ Section */}
        <section className="i ji ii db">
        
      <div className="bb ze ki xn 2xl:ud-px-0">
        <div className="tc sf yo zf kq">
          <div className="ro1">
            <div className="animate_top rounded-md shadow-solid-13 bg-white dark:bg-blacksection border border-stroke dark:border-strokedark p-7.5 md:p-10">
            
            <div className="container">
               <div className="left">
          <img src="../images/wh3.png" className="vd" alt="Blog" />
        </div>
          <div className="right">
<h2 className="ek vj 2xl:ud-text-title-lg kk wm nb gb mk">
 Precision in the Inbox: Turning Email Engagement into Measurable B2B Revenue
              </h2>
                <ul className="tc uf cg 2xl:ud-gap-15 fb">
                <li>
                  <span className="rc kk wm">Published On: </span> Oct 20, 2025
                   
                </li>
                <li className="jutfy">
                   <span className="rc kk wm"><b>Published by:</b></span> Pinakinedge Media
                </li>
              </ul>
          </div>
            </div>
            

                <p className="mk3 ij">
             Precision turns communication into conversion
              </p>
             
             
 <p className="jutfy">
In an era where buyers are overwhelmed with information and digital noise, email marketing remains one of the most effective and measurable tools for B2B demand generation. However, success in 2025 isn’t just about sending more emails — it’s about sending the right message, to the right audience, at the right time. Precision and personalization are the new cornerstones of email marketing ROI.
           </p>
               <p className="mb bgimh">
           The Shift Toward Precision Marketing
              </p>
 <p className="jutfy">
Traditional email marketing was once a volume game — mass sends, static lists, and generic offers. But today’s B2B buyers expect relevance, context, and timing. By leveraging firmographic, technographic, and intent data, marketers can now pinpoint who is in-market, what challenges they’re researching, and where they are in the buyer’s journey. This precision-driven approach helps align marketing efforts directly with sales objectives, shortening conversion cycles and optimizing ROI.
              </p>

               <p className="mb bgimh">
              Turning Engagement into Revenue
              </p>
 <p className="jutfy">
  Modern email marketing goes beyond open rates and click-through metrics. The true value lies in conversion intelligence — understanding what content drives action and how each interaction influences the sales funnel. AI and machine learning tools enable marketers to segment dynamically, automate nurturing sequences, and personalize at scale. This ensures that every email contributes to pipeline growth and tangible business outcomes
              </p>


                <p className="mb bgimh">
The ROI Advantage

              </p>

                <p className="jutfy">
                  Email marketing offers measurable ROI and cost efficiency. With advanced analytics, marketers can directly attribute deals to campaigns, monitor conversion velocity, and optimize future outreach based on performance insights. Integrating CRM, marketing automation, and AI-driven analytics provides end-to-end visibility — from first touch to closed deal — resulting in better alignment, faster sales, and higher-quality leads.
            </p>
                <p className="mb bgimh">
         How Pinakinedge Media Helps
              </p>
              
 <p className="jutfy">
  At <b>Pinakinedge Media</b>, we specialize in helping B2B brands transform email marketing into a predictive revenue engine. Our expertise lies in combining creativity, automation, and data intelligence to deliver high-performing campaigns that convert. Data-Driven 
<b>Targeting:</b>  We enrich your email lists with intent, firmographic, and behavioral insights to reach the most qualified prospects. 
<br/><br/>
<b>Personalized Campaign Design:</b> Our team crafts tailored messaging and dynamic workflows to engage buyers based on their interests and journey stage. 
          <br/><br/>
          <b>AI-Powered Optimization:</b> We leverage analytics and machine learning to continually refine delivery timing, subject lines, and content for maximum performance. 
           <br/><br/>
          <b> ROI-Focused Reporting:</b> Every campaign is tracked to measurable KPIs — from engagement metrics to pipeline impact — giving you full visibility into ROI.
              </p>
                <p className="mb bgimh">
            
Conclusion
              </p>
             <p className="jutfy">
              Email remains the heartbeat of B2B communication, but precision defines success. In 2025, the brands that thrive will be those that treat email not as a broadcast channel but as a data-driven ecosystem — one that intelligently nurtures leads, accelerates conversions, and amplifies ROI. With the right strategy and partner, your next great revenue opportunity could be just one email away.
              </p>
              <div className="animate_top w-full nn/5 vo/3 vk sg hh sm yh tq">
              <form onSubmit={(e) => handleContactSubmit(e)}>
  <div className="tc sf yo ap zf xi1">
    <div className="vd to/2">
      <label className="rc" htmlFor="fullname">Full name</label>
      <input
        type="text"
        name="fullname"
        id="fullname"
        value={contactForm.fullname}
        onChange={handleContactChange}
        className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
      />
    </div>

    <div className="vd to/2">
      <label className="rc" htmlFor="company">Company</label>
      <input
        type="text"
        name="company"
        id="company"
        value={contactForm.company}
        onChange={handleContactChange}
        className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
      />
    </div>
  </div>

  <div className="tc sf yo ap zf xi1">
    <div className="vd to/2">
      <label className="rc" htmlFor="website">Phone number</label>
        <input
  type="text"
  name="phone"
  id="phone"
  value={contactForm.phone}
  onChange={(e) => {
    // Allow only digits
    const value = e.target.value.replace(/\D/g, "");
    setContactForm((prev) => ({ ...prev, phone: value }));
  }}
  maxLength={10} // optional: limit to 10 digits
  className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
/>

    </div>

    <div className="vd to/2">
      <label className="rc" htmlFor="email">Email address</label>
      <input
        type="email"
        name="email"
        id="email"
        value={contactForm.email}
        onChange={handleContactChange}
        className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
      />
    </div>
  </div>
  <div className="fb">
    <label className="rc" htmlFor="message">Comment</label>
    <textarea
      placeholder="Comment"
      rows="3"
      name="message"
      id="message"
      value={contactForm.message}
      onChange={handleContactChange}
      className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 ci"
    ></textarea>
  </div>

  <div className="tc xf">
      <button
  type="submit"
  className="vc rg lk gh ml il hi gi _l"
  disabled={loading}
  onClick={() => {
    setFormType("White Paper3: Precision in the Inbox: Turning Email Engagement into Measurable B2B Revenue");
  }}
>
  {loading ? "Please wait..." : " Post Comment"}
</button>
  </div>
</form>
            </div>
 
            </div>
          </div>
        </div>
      </div>
    </section>
       
      </main>
      <Footer />
    </div>
  );
}

export default Whitepapers3;
